import React, { PropTypes } from 'react'
import Paragraph from './Paragraph'
import _ from 'lodash'

const Container = ({ entity }) => {

  const items = _.get(entity, 'fieldReusableBlock.entity.fieldContent', [])

  return (
    items.map(item => (
      <Paragraph entity={item.entity} />
    ))
  )
}

export default Container
